import { useState, useEffect } from "react";
import {
  LayoutDashboard,
  ClipboardList,
  Clock,
  AlertTriangle,
  CheckCircle,
  Bell,
  Settings,
  LogOut
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmDialog from "./ConfirmDialog";

export default function DistrictSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState(null);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);
  }, []);

  // ✅ District-specific routes
  const menu = [
    { label: "Dashboard", icon: <LayoutDashboard size={18} />, path: "/district-dashboard" },
    { label: "Submitted ESMPs", icon: <ClipboardList size={18} />, path: "/district/submitted-esmp" },
    { label: "Pending Reviews", icon: <Clock size={18} />, path: "/district/pending-reviews" },
    { label: "Overdue ESMPs", icon: <AlertTriangle size={18} />, path: "/district/overdue" },
    { label: "Returned / Rejected ESMPs", icon: <CheckCircle size={18} />, path: "/district/returned-esmp" },
    { label: "Approved ESMPs", icon: <CheckCircle size={18} />, path: "/district/approved-esmp" },
    { label: "Notifications", icon: <Bell size={18} />, path: "/district/notifications" },
    { label: "Settings", icon: <Settings size={18} />, path: "/district/settings" },
  ];

  const handleLogout = () => {
    setShowLogoutDialog(true);
  };

  const confirmLogout = () => {
    setShowLogoutDialog(false);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <aside className="w-72 h-screen shrink-0 bg-white shadow-lg flex flex-col">
      {/* Brand Header */}
      <div className="px-5 py-6 bg-gradient-to-r from-green-800 to-green-600 text-white">
        <div className="flex items-center gap-3">
          <div className="bg-white text-green-700 rounded-full w-10 h-10 flex items-center justify-center font-bold">
            {user?.name ? user.name[0].toUpperCase() : "D"}
          </div>
          <div>
            <h3 className="text-sm font-semibold">
              {user?.name || "ESMP Writer"}
            </h3>
            <p className="text-xs text-green-200">
              {user?.district || "ESMP Writer Dashboard"}
            </p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="px-4 py-4 flex-1">
        <ul className="space-y-2 text-sm">
          {menu.map((item, i) => {
            const isActive = location.pathname === item.path;
            return (
              <li
                key={i}
                onClick={() => navigate(item.path)}
                className={`flex items-center gap-3 px-4 py-2.5 rounded-lg cursor-pointer transition-all ${
                  isActive
                    ? "bg-green-100 text-green-700 font-semibold border-l-4 border-green-600"
                    : "text-gray-700 hover:bg-green-50 hover:text-green-700"
                }`}
              >
                <span className="flex items-center">{item.icon}</span>
                <span>{item.label}</span>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="border-t px-5 py-4 space-y-3">
        <button
          className="text-sm text-gray-600 hover:text-green-700 transition"
          onClick={() => alert("District support coming soon")}
        >
          Help
        </button>

        <button
          className="flex items-center gap-2 text-sm text-red-500 hover:text-red-600 transition"
          onClick={handleLogout}
        >
          <LogOut size={18} />
          Log out
        </button>
      </div>

      <ConfirmDialog
        open={showLogoutDialog}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        confirmText="Logout"
        cancelText="Cancel"
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutDialog(false)}
      />
    </aside>
  );
}

